import { getOrganizationById, getOrganizations } from '@/services';
import { useQuery } from '@tanstack/react-query';

interface UseOrganizationProps {
  organizationId: string;
  populate: boolean;
  queryKey: string;
}
export const useOrganization = ({ organizationId, populate, queryKey }: UseOrganizationProps) => {
  const { data: organizationData } = useQuery({
    queryKey: [queryKey, organizationId],
    queryFn: async () => getOrganizationById(organizationId, populate),
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh
    refetchOnMount: false, // Don't refetch if data is cached and fresh
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
  });
  return { organizationData };
};

export const useOrganizations = (enabled: boolean) => {
  return useQuery({
    queryKey: ['organizations'],
    queryFn: async () => {
      const response = await getOrganizations();
      return response;
    },
    enabled,
  });
};
